import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DetailsTable from 'components/DetailsTable';
import React from 'react';


const ValidationDetailsPreviewDialog = ({ onValidationDetailsDialogClose, validationDetails, translate }) => {
	const { errors = [], warnings = [] } = validationDetails;

	return (
		<Dialog open maxWidth="sm" onClose={onValidationDetailsDialogClose}>
			<DialogTitle>
				{translate("osfc.dialogs.document-templates.validation.title")}
			</DialogTitle>
			<DialogContent>
				{errors.length ? (
					<DetailsTable 
						entries={errors} 
						translate={translate}
						entityName="errors"
						dialogName="document-templates.validation"
					/>
				) : null}
				{warnings.length ? (
					<DetailsTable 
						entries={warnings} 
						translate={translate}
						entityName="warnings"
						dialogName="document-templates.validation"
					/>
				) : null}
				<Box mt={2}></Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onValidationDetailsDialogClose} color="primary">
					{translate("ra.action.cancel")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export {
	ValidationDetailsPreviewDialog,
};
